import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { ProcessActivity, UserService } from "../user.service";

@Injectable()
export class AdminAuth implements CanActivate {
    constructor(private router: Router, private service: UserService) {}

    canActivate(): Observable<boolean> {
        return this.isAllowedAccess();
    }

    private isAllowedAccess(): Observable<boolean> {
        let returnVal = of(false);
        returnVal = Observable.create((observer) => {
            this.service.getUser().subscribe(
                (data) => {
                    this.service.setUser(data);

                    var admin =
                        data.processes.find((s) => s.process == "Admin") ||
                        new ProcessActivity();

                    var allowed = admin.activity == "Edit";

                    observer.next(allowed);
                    observer.complete();

                    if (!allowed) this.router.navigateByUrl("/unauthorized");
                },
                (err) => {
                    observer.next(false);
                    observer.complete();

                    this.router.navigateByUrl("/unauthorized");
                }
            );
        });

        return returnVal;
    }
}
